var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.inoudata.showAMsched
    ? _c(
        "span",
        [
          _c(
            "b-row",
            { staticClass: "mt-5" },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "12", sm: "10" } },
                [
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("financial-tools.initialAmortizationPeriod")
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "12", sm: "10" } },
                [
                  _c("h3", [
                    _vm._v(
                      "(" +
                        _vm._s(
                          _vm.$t(
                            "financial-tools.semiAnnualInterestCompounding"
                          )
                        ) +
                        ")"
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("financial-tools.mortgage_amount")) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatMoney(_vm.inoudata.mortgageAmount)) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("financial-tools.originalPayment")) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatMoney(_vm.inoudata.PandI)) +
                    "\n    "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("financial-tools.interest_rate")) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatRate(_vm.inoudata.interestRate / 100)) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _vm.inoudata.incpayValue * _vm.inoudata.incYears > 0
                ? _c("b-col", { attrs: { cols: "12", sm: "4" } }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t("financial-tools.mortgagePaymentIncrease") +
                            ": " +
                            (_vm.inoudata.incpayType == "%"
                              ? _vm.inoudata.incpayValue.toLocaleString(
                                  _vm.$root.$i18n.locale,
                                  {}
                                ) + "%"
                              : _vm.formatMoney(_vm.inoudata.incpayValue)) +
                            " /#" +
                            _vm.capitalize(_vm.$t("financial-tools.yearss")) +
                            "=" +
                            _vm.inoudata.incYears
                        ) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("financial-tools.paymentFrequency")) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.capitalize(
                        _vm.$t("application-form." + _vm.inoudata.frequency)
                      )
                    ) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _vm.inoudata.lumpAmt * _vm.inoudata.lumpYears > 0
                ? _c("b-col", { attrs: { cols: "12", sm: "4" } }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t("financial-tools.lumpSumPayment") +
                            ": " +
                            _vm.formatMoney(_vm.inoudata.lumpAmt) +
                            " /#" +
                            _vm.capitalize(_vm.$t("financial-tools.yearss")) +
                            "=" +
                            _vm.inoudata.lumpYears
                        ) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("financial-tools.amortization_period")) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      Math.trunc(_vm.revamortizPeriodMths / 12) +
                        " " +
                        _vm.capitalize(_vm.$t("financial-tools.yearss")) +
                        ", " +
                        Math.round(_vm.revamortizPeriodMths % 12) +
                        " " +
                        _vm.capitalize(_vm.$t("financial-tools.monthss"))
                    ) +
                    "\n    "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr", {
            staticClass: "w-100 mt-2",
            staticStyle: { "border-top": "3px solid black" },
          }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2 mb-2 bold" },
            [
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("financial-tools.period")) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("financial-tools.totalPaid")) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("financial-tools.interest")) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("financial-tools.principal")) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("application-form.balance")) +
                    ":\n    "
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.detailRecords, function (detRec) {
            return _c(
              "b-row",
              { key: detRec.headType + detRec.payAdd, staticClass: "mt-1" },
              [
                detRec.headType == "detail"
                  ? [
                      _c("b-col", { attrs: { cols: "12", sm: "1" } }, [
                        _c("span", { staticClass: "ml-2" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("financial-tools.pmt")) + ":"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("b-col", { attrs: { cols: "12", sm: "1" } }, [
                        _vm._v(
                          "\n        " + _vm._s(detRec.payAdd) + "\n      "
                        ),
                      ]),
                    ]
                  : detRec.headType == "yearTotal"
                  ? [
                      _c(
                        "b-col",
                        { staticClass: "bold", attrs: { cols: "12", sm: "2" } },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.capitalize(_vm.$t("financial-tools.year")) +
                                  " " +
                                  detRec.payAdd +
                                  " " +
                                  _vm.$t("financial-tools.totals")
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  : [
                      _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.$t("financial-tools.totals"))),
                        ]),
                      ]),
                    ],
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.formatMoney(detRec.totalPaid)) +
                      "\n    "
                  ),
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.formatMoney(detRec.interest)) +
                      "\n    "
                  ),
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.formatMoney(detRec.principal)) +
                      "\n    "
                  ),
                ]),
                _vm._v(" "),
                detRec.headType != "Total"
                  ? _c("b-col", { attrs: { cols: "12", sm: "2" } }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.formatMoney(detRec.principalBal)) +
                          "\n    "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                detRec.headType != "detail"
                  ? _c("hr", {
                      staticClass: "w-100 mt-2",
                      staticStyle: { "border-top": "2px solid black" },
                    })
                  : _vm._e(),
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "simple-button",
                {
                  staticClass: "ml-md-2 ml-0",
                  attrs: { "class-name": "btn-sm", type: "white" },
                  on: { click: _vm.inoudata.doHideAMsched },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("global.words.back")) + "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }